import { createRoot } from 'react-dom/client';
import { App } from './App.js';
import './styles.css';

createRoot(document.getElementById('root')!).render(<App />);

/**
 * Service worker registration.
 *
 * Production only. localhost counts as a secure context, so registering in dev
 * would have the worker serve cached Vite modules on reload -- silently running
 * stale pricing-engine code, which is the one bug this project can least afford.
 *
 * Requires a secure context either way: over a plain LAN IP
 * (http://192.168.x.x) the browser refuses to register a worker at all, which is
 * why on-device testing goes through `adb reverse` or an HTTPS tunnel.
 */
if (import.meta.env.PROD && 'serviceWorker' in navigator && window.isSecureContext) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch((err) => {
      console.warn('[bid-tool] service worker registration failed', err);
    });
  });
} else if (import.meta.env.PROD && !window.isSecureContext) {
  console.warn(
    '[bid-tool] not a secure context, so offline mode is unavailable. ' +
      'Use localhost, adb reverse, or an HTTPS tunnel.',
  );
}
